import styled from "styled-components";
import NavItem from "../../../bootstrap/NavItem";
import Ul from "../../../bootstrap/Ul";
import { Color } from "../../../color/index.js";

export const Point = styled.div`
  width: 100%;
  padding: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #d1d1d1;
  box-sizing: border-box;
`;

export const CommonHeader = styled.h4`
  margin: 0 0 5px 0;
  font-size: 12px;
  line-height: 1.4;
  text-transform: uppercase;
  color: #172839;
  font-weight: 500;
`;

export const BoardingAndDroppingPointUl = styled(Ul)`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  list-style: none;
`;

export const CommonNavItem = styled(NavItem)`
  padding: 8px 0;
  display: flex;
  align-items: flex-start;
`;

export const PointLabel = styled.label`
  display: flex;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.4;
`;

export const Time = styled.div`
  padding: 0 12px 0 8px;
  font-size: 12px;
  font-weight: 500;
`;

export const LocationName = styled.div`
  font-size: 13px;
  line-height: 1.4;
`;

export const LocationRoadName = styled.div`
  font-size: 11px;
  line-height: 1.4;
`;

/* Boarding and dropping dropdowns */
export const Select = styled.select`
  display: block;
  width: 100%;
  min-width: 0;
  min-height: 40px;
  padding: 9px 12px;
  margin: 0 0 12px 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fff;
  color: #172839;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.4;
  box-sizing: border-box;
  outline: none;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${Color};
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
    background-color: #f5f5f5;
  }

  option {
    font-size: 13px;
    color: #172839;
    background-color: #fff;
  }

  @media (max-width: 576px) {
    min-height: 38px;
    padding: 8px 10px;
    font-size: 12px;
  }
`;

export const Input = styled.input`
  cursor: pointer;
`;